export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" fill="#111111" />
    <path d="M8 7h16v4H12v3h12v11H8v-4h12v-3H8z" fill="#F4F2EE" />
    <rect x="24" y="25" width="3" height="3" fill="#E2541B" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span className={`font-display font-extrabold tracking-[-0.04em] leading-none ${className}`}>
    Sviin<span className="text-[#E2541B]">.</span>
  </span>
);
